import PopupModal, { PopupButton } from "./Modal";

export default function MessageModal({
  open,
  closeModal,
  heading,
  messages,
}) {
  return (
    <PopupModal
      open={open}
      heading={heading || "Confirmation"}
      message={
        <ul>
          {messages.map((msg, idx) => (
            <li key={`msg_${idx}`}>{msg}</li>
          ))}
        </ul>
      }
    >
      <PopupButton onClick={closeModal}>Close</PopupButton>
    </PopupModal>
  );
}
